import { useEffect, useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import Chapters from "../components/Chapters";
import About from "../components/About";
import Footer from "../components/Footer";
import CartDrawer from "../components/CartDrawer";
import Checkout from "../components/Checkout";
import { useCart } from "../context/CartContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Home() {
  const [products, setProducts] = useState([]);
  const [checkoutOpen, setCheckoutOpen] = useState(false);
  const { setOpen } = useCart();

  useEffect(() => {
    axios.get(`${API}/products`).then(({ data }) => setProducts(data.filter((p) => p.chapter <= 3))).catch(() => {});
  }, []);

  useEffect(() => {
    if (products.length && window.location.hash) {
      const el = document.querySelector(window.location.hash);
      if (el) setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
    }
  }, [products]);

  return (
    <div data-testid="home-page" className="min-h-screen bg-ivory">
      <Header />
      <Hero />
      <Marquee />
      <Chapters products={products} />
      <About />
      <Footer />
      <CartDrawer onCheckout={() => { setOpen(false); setCheckoutOpen(true); }} />
      <Checkout open={checkoutOpen} onClose={() => setCheckoutOpen(false)} />
    </div>
  );
}
